module.exports = __webpack_public_path__ + "img/bottiglia-vino.d90f1d68.jpg";